export default {
    /**
     *
     * @returns {Promise<unknown>}
     */
    async getCards() {
        return await ApiClient.get(`/onboarding/onboarding-screen`);
    },
};
